module.exports = __webpack_public_path__ + "static/media/4421.a4e57a99.jpg";